import { render, staticRenderFns } from "./employer-assign-form.vue?vue&type=template&id=3c16bc26"
import script from "./employer-assign-form.vue?vue&type=script&lang=js"
export * from "./employer-assign-form.vue?vue&type=script&lang=js"
import style0 from "./employer-assign-form.vue?vue&type=style&index=0&id=3c16bc26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports